
const INIT_CRYPTO_REGISTRATION_FLAGS = "initCryptoFlags";

export {
	INIT_CRYPTO_REGISTRATION_FLAGS
};